(() => {
  if (window.HollowByobCartGuard) return;
  const originalFetch = window.fetch.bind(window);
  const routeRoot = window.Shopify?.routes?.root || '/';
  const base = routeRoot.endsWith('/') ? routeRoot : routeRoot + '/';
  const rules = {
    hat: { productId: '9005569671337', threshold: 4900 },
    beanie: { productId: '8586396172457', threshold: 9900 }
  };
  const giftProductIds = new Set(Object.values(rules).map(rule => rule.productId));
  const marked = item => Object.prototype.hasOwnProperty.call(item.properties || {}, '_byob_gift');
  const free = item => item.final_line_price === 0 && item.final_price === 0;
  const spendFor = (cart, bundle, mode) => cart.items.filter(item =>
    !marked(item) && !giftProductIds.has(String(item.product_id)) &&
    item.properties?._byob_bundle === bundle && item.properties?._byob_mode === mode &&
    Number.isSafeInteger(item.quantity) && item.quantity > 0 &&
    Number.isSafeInteger(item.final_line_price) && item.final_line_price >= 0
  ).reduce((sum, item) => sum + item.final_line_price, 0);
  let queue = Promise.resolve();
  const serialize = task => {
    const next = queue.then(task);
    queue = next.catch(error => console.error('[byob-cart] Cart operation failed', error));
    return next;
  };
  const request = async (path, body) => {
    const response = await originalFetch(base + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(`BYOB cart cleanup request failed (${response.status})`);
    return response.json();
  };
  const cleanupUpdates = cart => {
    const updates = {};
    const candidates = [];
    for (const gift of cart.items.filter(marked)) {
      const kind = gift.properties._byob_gift;
      const rule = Object.prototype.hasOwnProperty.call(rules, kind) ? rules[kind] : null;
      const bundle = gift.properties._byob_bundle;
      const eligible = rule && cart.currency === 'USD' &&
        String(gift.product_id) === rule.productId && typeof bundle === 'string' && bundle.trim() !== '' &&
        Number.isSafeInteger(gift.quantity) && gift.quantity > 0 && spendFor(cart, bundle, kind) >= rule.threshold;
      if (!eligible || (gift.quantity === 1 && !free(gift))) updates[gift.key] = 0;
      else candidates.push(gift);
    }
    candidates.sort((a, b) => Number(b.quantity === 1 && free(b)) - Number(a.quantity === 1 && free(a)));
    candidates.forEach((gift, index) => {
      if (index > 0) updates[gift.key] = 0;
      else if (gift.quantity > 1) updates[gift.key] = 1;
    });
    return updates;
  };
  const reconcile = async () => {
    let cart = await request('cart.js');
    for (let pass = 0; pass < 3; pass++) {
      const updates = cleanupUpdates(cart);
      if (!Object.keys(updates).length) return cart;
      await request('cart/update.js', { updates });
      cart = await request('cart.js');
    }
    if (Object.keys(cleanupUpdates(cart)).length) throw new Error('BYOB cart gift cleanup did not settle after three checks');
    return cart;
  };
  window.fetch = (input, init) => {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = String(init?.method || input?.method || 'GET').toUpperCase();
    const mutation = url.origin === location.origin && method === 'POST' && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    if (!mutation) return originalFetch(input, init);
    return serialize(async () => {
      const response = await originalFetch(input, init);
      if (response.ok) {
        try { await reconcile(); }
        catch (error) { console.error('[byob-cart] Could not clean up gifts after cart change', error); }
      }
      return response;
    });
  };
  window.HollowByobCartGuard = { reconcile: () => serialize(reconcile) };
  const check = () => window.HollowByobCartGuard.reconcile().catch(error => console.error('[byob-cart] Could not check cart gifts', error));
  window.addEventListener('pageshow', check);
  if (document.readyState === 'complete') check();
})();
